import { createConfirmation } from 'react-confirm'
import ModalBody from "./ModalBody";

const modal = createConfirmation(ModalBody);

export default function (opts = {}) {
  // if(opts.type == 'potentialStudent'){
  //   return modal(opts)
  // }
  if (!Array.isArray(opts.students) || opts.students.length == 0) {
    throw new Error(`This modal requires an array of student objects { students: [student] }`);
  }
  return modal(opts);
}



// WEBPACK FOOTER //
// ./src/template/Modals/EnrollClass/index.js